import axios from 'axios';
import { API_URL } from '../config';

const API = API_URL;

// Get auth headers
const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

export const smartPlaylistsApi = {
  // Generate a smart playlist based on criteria
  generate: async (criteria) => {
    const response = await axios.post(`${API}/smart-playlists/generate`, criteria, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Save smart playlist criteria for reuse
  save: async (criteria) => {
    const response = await axios.post(`${API}/smart-playlists/save`, criteria, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Update an existing smart playlist
  update: async (playlistId, criteria) => {
    const response = await axios.put(`${API}/smart-playlists/${playlistId}`, criteria, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Get all saved smart playlists
  getAll: async () => {
    const response = await axios.get(`${API}/smart-playlists`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Delete a smart playlist
  delete: async (playlistId) => {
    const response = await axios.delete(`${API}/smart-playlists/${playlistId}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
};
